import {
  reactIcon,
  cssIcon,
  javaIcon,
  gradleIcon,
  typescriptIcon,
  sassIcon,
  reduxIcon,
  rxjsIcon,
  reduxObservable,
  reactqueryIcon,
  expressIcon,
  cypressIcon,
  webpackIcon,
  vueIcon,
  relayIcon,
  flowIcon,
  hackIcon,
  graphqlIcon,
  entIcon,
  unduxIcon,
  mysqlIcon,
} from "../utils/Icons";

import type { ExperienceObjProps } from "@types";

export const experiences: ExperienceObjProps[] = [
  {
    title: "Meta",
    date: "May 2022 - Aug 2022",
    role: "Enterprise Engineer Intern",
    role2: "EE Intern",
    vision:
      "Give people the power to build community and bring the world closer together.",
    details: [
      "⪼	Spearheaded the announcement and notification feature in finance tool used by teams worldwide.",
      "⪼	Developed data models, APIs for notification subscriptions using Hack, Ent, GraphQL, MySQL.",
      "⪼  Developed reusable user interfaces to support customizable announcements and notification using React, Relay, GraphQL.",
      "⪼  Optimized notification query by comparing through the spectrum of single SQL query to multiple SQL query.",
      "⪼  Led cross-functional efforts with XFN teams to plan, identify and brainstorm on features and requirements as well as timeline.",
      "⪼  Researched, create guide and presented to my team on how to use Type-Safe updaters in Relay and shared learning points on using Relay and GraphQL during the internship itself.",
      "⪼  Utilized render-as-you-fetch model for frontend development to optimize and speed up page load.",
    ],
    stack: [
      reactIcon,
      flowIcon,
      graphqlIcon,
      relayIcon,
      unduxIcon,
      hackIcon,
      entIcon,
      mysqlIcon,
    ],
    link: "https://about.facebook.com/",
  },
  {
    title: "Shopee",
    role: "Software Engineer Intern",
    role2: "SWE Intern",
    date: "Aug 2021 - Dec 2021",
    vision:
      "We believe online shopping should be accessible, easy and enjoyable.",
    details: [
      "⪼	Developed an event management web app using React, Sass, Webpack, Redux, Redux-Thunk, React-testing library, Express.",
      "⪼	Built an internal tool to intercept APIs calls and mock data for the intercepted endpoints and display the intercept endpoints to improve developers experience using Chrome’s API, Node.",
      "⪼  Implemented and refactored end-to-end tests for multiple pages using Cypress and introduce multiple locale testing.",
      "⪼  Developed scripts for developers to speed up their initial developments by generating the necessary configurations.",
      "⪼  Worked on client-facing checkout features as well as seller-facing finance features",
    ],
    stack: [
      typescriptIcon,
      reactIcon,
      reduxIcon,
      expressIcon,
      webpackIcon,
      cypressIcon,
      vueIcon,
      sassIcon,
    ],
    link: "https://careers.shopee.sg/about",
  },
  {
    title: "Motional",
    role: "Software Engineer Intern",
    role2: "SWE Intern",
    date: "May 2021 - Aug 2021",
    vision:
      "We're making driverless vehicles a safe, reliable, and accessible reality",
    details: [
      "⪼	Spearheaded the launch of new website to facilitate extraction and reading data that is being produced by the autonomous vehicles.",
      "⪼	Improved the accessibility of the Redux store by redesigning the structure of the Redux Store by normalizing the data.",
      "⪼  Redesigned the API query to utilize React-Query instead to speed up the APIs and add a layer of caching to speed up future fetching.",
    ],
    stack: [
      typescriptIcon,
      reactIcon,
      reduxIcon,
      reactqueryIcon,
      rxjsIcon,
      reduxObservable,
      sassIcon,
    ],
    link: "https://motional.com/about",
  },
  {
    title: "NUS",
    role: "Software Engineer",
    role2: "SWE",
    date: "Jan 2021 - Jul 2021",
    details: [
      "⪼ Contributor for the main team for an open-source software website that is being used by over 500 NUS students per semester.",
      "⪼ Conducted and coordinated code and design documentation reviews as well as reviewing pull request from other members.",
    ],
    stack: [javaIcon, cssIcon, gradleIcon],
    link: "https://se-education.org/docs/team.html#past-contributors",
  },
];
